export default function addAccordion() {
  const isPresent = document.querySelector(".accordion");
  if (!isPresent) {
    return;
  }

  const accordions = document.querySelectorAll(".accordion");

  accordions.forEach((accordion) => {
    const accordionHeaders = accordion.querySelectorAll(
      ".accordion-item__header"
    );

    function openAccordion() {
      const parent = this.parentElement;
      const article = this.nextElementSibling;

      if (!parent.classList.contains("open")) {
        parent.classList.add("open");
        article.style.maxHeight = `${article.scrollHeight}px`;
      } else {
        parent.classList.remove("open");
        article.style.maxHeight = "0px";
      }
    }

    for (let i = 0; i < accordionHeaders.length; i++) {
      accordionHeaders[i].addEventListener("click", openAccordion);

      // function openFirstTabOnDesktop() {
      //   const belowTabletScreen = window.matchMedia("(max-width: 767px)");

      //   belowTabletScreen.addListener(handleScreenChange);

      //   function handleScreenChange(e) {
      //     if (!e.matches) {
      //       if (i === 0) {
      //         setTimeout(function () {
      //           accordionHeaders[0].click();
      //         }, 200);
      //       }
      //     }
      //   }

      //   // Run it initially
      //   handleScreenChange(belowTabletScreen);
      // }

      // openFirstTabOnDesktop();
    }
  });
}
